import { useAppDispatch, useAppSelector } from '@/Hook/hooks';
import { loadWidgetGroup } from '@/Redux/Ducks/dashboardSlice';
import { KeyValueObject } from '@/UI/Interfaces/IBaseUI';
import { ControlTranslation } from 'AlignComponents';
import React, { useEffect, useState } from 'react';
import { FiPieChart } from 'react-icons/fi';
import Select, { components } from 'react-select';

const customStyles = {
  container: (base: any) => ({
    ...base,
    width: '150px',
  }),
  control: (base: any) => ({
    ...base,
    border: "1px solid #cbcbcb",
    // This line disable the blue border
    // height: '42px',
    // borderRadius: '6px'
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #0ac3da',
    }
  }),
  valueContainer: (base: any) => ({
    ...base,
    fontSize: '11px',
    color: "#000",
    fontWeight: "bold"
  }),
  placeholder: (base: any) => ({
    ...base,
    fontSize: "9px",
    color: "#575757ab",
    fontWeight: "normal",
    position: "relative",
    top: "2px",
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  option: (base: any, state: any) => ({
    ...base,
    fontSize: '11px',
    backgroundColor: state.isSelected ? '#0ac3da' : 'inherit',
    '&:hover': {
      backgroundColor: state.isSelected ? '#0ac3da' : '#e7f9fb'
    }
  }),
}

const { ValueContainer, Placeholder, SingleValue } = components;

const CustomValueContainer = ({ children, ...props }: any) => {
  return (
    <ValueContainer {...props}>
      {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const CustomSingleValue = (props: any) => {
  return (
    <SingleValue {...props}>
      <div style={{ display: "flex", whiteSpace: "nowrap", alignItems: "center", overflow: "hidden", gap: "10px" }}>
        <FiPieChart style={{ flexShrink: 0 }} size={20} />
        <div>
          <Placeholder {...props} isFocused={props.isFocused}>
            <ControlTranslation system={true} controlId="lbldashboard" />
          </Placeholder>
          {props.data.label}
        </div>
      </div>
    </SingleValue>
  );
};

const DashboardSelector = () => {
  const dispatch = useAppDispatch();

  const [options, setOptions] = useState<any>([]);

  const { activeWidgetGroup, widgetGroups } = useAppSelector(state => ({
    activeWidgetGroup: state.Dashboard.activeWidget.widgetgroupno,
    widgetGroups: state.Dashboard.widgetGroups
  }));

  useEffect(() => {
    setOptions(widgetGroups.map((x) => ({
      value: x.widgetgroupno,
      label: x.widgetgroupstxt
    })));
  }, [widgetGroups]);

  const changeWidgetGroup = (option: any) => {
    dispatch(loadWidgetGroup(option.value));
  }

  if (activeWidgetGroup) {
    return (
      <div>
        <Select
          components={{ ValueContainer: CustomValueContainer, SingleValue: CustomSingleValue }}
          options={options}
          value={options.find((x: any) => x.value == activeWidgetGroup)}
          onChange={changeWidgetGroup}
          styles={customStyles}
        />
      </div>
    )
  } else return null

}

export default DashboardSelector;